import React, { useState ,useEffect} from "react";
import BgCheckOut from "../../images/bgcheckOut.png";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import BackButton from "../bars/BackButton";
import ButtonLoader from "../../components/loaders/ButtonLoader";
import { fetchRoomNoAndPhoneNo, setRoomNoAndPhoneNo } from "../../utils/util";
import { useNavigate,useLocation } from "react-router-dom";
import { ExtendStaySubmitButtonClick } from "../../utils/Analytics";

function ExtendStay() {

  const location = useLocation();
  const navigate = useNavigate();
 const extendStaydata = location.state?.extendStaydata ? location.state?.extendStaydata : null;
 console.log(" extendStaydata === null ",extendStaydata === null ? "" : extendStaydata)
 const hotelId = localStorage.getItem("hotel-id");
  const reservationId = localStorage.getItem("reservationId");
  const appUserId = localStorage.getItem("appUserId");
  const guestId = localStorage.getItem("guestId");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [comment, setComment] = useState(extendStaydata === null ? "" : extendStaydata.comment);
  const storedData = fetchRoomNoAndPhoneNo();
   const [roomNumber, setRoomNumber] = useState(storedData?.room);
  const [toDate, setToDate] = useState(extendStaydata === null ? "" : extendStaydata.toDate);
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const initialDate = `${year}-${month}-${day}`;
  const reservationData = JSON.parse(localStorage.getItem("guestDetailsArray"));
  var datetime = new Date(reservationData.dateOut);
  const [alreadyReq,setAlreadyReq] = useState(false);
    // Extracting the date part
  var date_out =  datetime.toISOString().split("T")[0];
  //This code is used to set the minimum date as one day after the date_out to block the date_out from being selected in the date picker
  const minDate = new Date(date_out);
  minDate.setDate(minDate.getDate() + 1); // Add 1 day
  const formattedMinDate = minDate.toISOString().split("T")[0];

// edite extend Stay
const [is_edit,setis_edit] = useState(false);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const editStatus = queryParams.has('is_edit') && queryParams.get('is_edit') === 'true';
    setis_edit(editStatus);
  }, [location.search]);
  console.log("is_edit from extend",is_edit);

  const submitExtent = (e) => {
    e.preventDefault();
    if (roomNumber === "") {
      setError("roomValidation");
    } else if (toDate === "") {
      setError("dateValidation");
    } else if (comment.trim() === "") {
      setError("Please give the reason for extend stay..");
    } else {
      ExtendStaySubmitButtonClick();
      extentRequest();
    }
  };

  const handleDate = (e) => {
    setToDate(e.target.value);
    setError("");
  };

  const handleRoom = (e) => {
    setRoomNumber(e.target.value);
    setError("");
  };

  const handleComment = (e) => {
    setComment(e.target.value);
  };

  const extentRequest = async (param) => {
    let data = JSON.stringify({
      hotelId,
      guestId,
      appUserId,
      reservationId,
      roomNumber,
      toDate: toDate,
      comments:comment,
      ...(is_edit === true && {is_edit}),
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/api/extendStayV21`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    setLoading(true);
    try {
      const response = await axios.request(config);
      console.log(response.data.success);
      if (response.data.success) {
        setError("");
        setSuccess(true);
        setRoomNoAndPhoneNo(roomNumber)
        setLoading(false);
        setis_edit(false);
        setTimeout(() => {
          setSuccess(false);
          navigate("../order-history")
        }, 2000);
      } else {
        setLoading(false);
        setError(response.data?.message);
      }
    } catch (error) {
      setLoading(false);
      setError("axios");
    }
  };

   // already request


  return (
    <div>
      <div>
        <div className="pb-28 relative">
          <img
            className="w-screen sm:h-[230px] h-[117px]"
            src={BgCheckOut}
            alt="bgHotelguide"
          />
          <div className="absolute top-3 left-3">
            <BackButton />
          </div>
          <div className="section-wrap mx-4 mt-6 sm:mt-14">
            <div className="guestName text-left">Extend Stay</div>
            <form onSubmit={submitExtent} className="flex flex-col">
              <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
                Your Room Number
              </label>
              <input
                onChange={handleRoom}
                className="mt-2 reqInput"
                type="text"
                value={roomNumber}
              />
              <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
                Preferred date
              </label>
              <input
                onChange={handleDate}
                value={toDate}
                min={formattedMinDate}
                 className="mt-2 reqInput"
                type="date"
              />
              <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
                Comments
              </label>
              <textarea
                value={comment}
                onChange={handleComment}
                className="mt-2 reqInput"
                type="textarea"
              />
              <button
                disabled={alreadyReq}
                className={` ${alreadyReq ? 'bookBtnInactive': 'bookBtn' } mt-10 max-w-[400px] relative`}
              >
                Request
                {loading && <ButtonLoader />}
              </button>
            </form>
          </div>
        </div>
        <div className="mt-10 fixed  bottom-5 left-1/2 -translate-x-1/2">
          {error == "roomValidation" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Please give room number..
              </div>
            </div>
          )}
          {alreadyReq ? (
            <div className="w-full flex justify-center">
              <div className="success-doc text-center mt-3">
              Your request has been sent. Please wait for further action
              </div>
            </div>
          ):('')}
          {error == "dateValidation" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Please select a date..
              </div>
            </div>
          )}
          {error == "axios" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                Somthing went wrong..
              </div>
            </div>
          )}
           {error != "axios" && error != "dateValidation"  &&  error && error != "roomValidation" && (
            <div className="w-full flex justify-center">
              <div className="error-doc text-center mt-3">
                {error}
              </div>
            </div>
          )}
          {success && (
            <div className="w-full flex justify-center">
              <div className="success-doc text-center mt-3">
                Successfully Requested
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ExtendStay;
